import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Copy, Save, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { API } from "@/lib/api";
import { fmtDateTime, formatApiErrorDetail } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const Copyable = ({ label, value, testid }) => (
  <div className="space-y-1.5">
    <Label className="text-xs">{label}</Label>
    <div className="flex gap-2">
      <Input readOnly value={value} className="font-mono text-xs" data-testid={testid} />
      <Button type="button" variant="outline" size="icon" onClick={() => { navigator.clipboard.writeText(value); toast.success("Copiato"); }}><Copy className="w-4 h-4" /></Button>
    </div>
  </div>
);

// Configurazione unica dell'app Meta (Super Admin): poi ogni ditta collega WhatsApp con un clic.
export const PlatformWhatsApp = () => {
  const [p, setP] = useState(null);
  const [f, setF] = useState({ app_id: "", config_id: "", app_secret: "" });
  useEffect(() => { api.get("/superadmin/whatsapp").then((r) => { setP(r.data); setF({ app_id: r.data.app_id, config_id: r.data.config_id, app_secret: "" }); }).catch(() => {}); }, []);
  const save = async () => {
    try { const r = await api.put("/superadmin/whatsapp", f); setP(r.data); setF({ ...f, app_secret: "" }); toast.success("Configurazione WhatsApp salvata"); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  if (!p) return null;
  const ready = p.app_id && p.config_id && p.has_app_secret;
  return (
    <div className="rounded-xl border border-border bg-card p-5 space-y-4" data-testid="platform-wa-card">
      <div className="flex items-center gap-2">
        <MessageCircle className="w-5 h-5 text-emerald-600" />
        <h3 className="font-heading font-semibold flex-1">WhatsApp per tutte le ditte (app Meta)</h3>
        <span className={`text-xs px-2.5 py-1 rounded-full ${ready ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>{ready ? `Attivo · ${p.connected_companies} ditte collegate` : "Da configurare"}</span>
      </div>
      <ol className="text-xs text-muted-foreground list-decimal pl-5 space-y-1">
        <li>Su developers.facebook.com crea un'app di tipo Business e aggiungi il prodotto WhatsApp.</li>
        <li>In «Facebook Login for Business» crea una configurazione Embedded Signup (permessi whatsapp_business_management e whatsapp_business_messaging) e copia il Configuration ID.</li>
        <li>In WhatsApp → Configurazione inserisci URL webhook e token qui sotto e iscriviti al campo «messages» (e «smb_message_echoes»).</li>
        <li>Diventa Tech Provider e invia l'App Review: fino ad allora il collegamento funziona solo per la tua attività e gli utenti di prova.</li>
      </ol>
      <div className="grid sm:grid-cols-3 gap-3">
        <div className="space-y-1.5"><Label className="text-xs">App ID</Label><Input value={f.app_id} onChange={(e) => setF({ ...f, app_id: e.target.value })} data-testid="platform-wa-app-id" /></div>
        <div className="space-y-1.5"><Label className="text-xs">Configuration ID</Label><Input value={f.config_id} onChange={(e) => setF({ ...f, config_id: e.target.value })} data-testid="platform-wa-config-id" /></div>
        <div className="space-y-1.5"><Label className="text-xs">App Secret</Label><Input type="password" value={f.app_secret} onChange={(e) => setF({ ...f, app_secret: e.target.value })} placeholder={p.has_app_secret ? "•••• salvato" : ""} data-testid="platform-wa-secret" /></div>
      </div>
      {p.verify_token && (
        <div className="grid sm:grid-cols-2 gap-3">
          <Copyable label="URL webhook (Callback URL)" value={`${API}/whatsapp/webhook`} testid="platform-wa-webhook-url" />
          <Copyable label="Token di verifica" value={p.verify_token} testid="platform-wa-verify-token" />
        </div>
      )}
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <span className="text-xs text-muted-foreground flex items-center gap-1.5">{p.last_webhook_at ? <><CheckCircle2 className="w-4 h-4 text-emerald-600" /> Ultimo evento da Meta: {fmtDateTime(p.last_webhook_at)}</> : "Nessun evento ricevuto da Meta"}</span>
        <Button onClick={save} data-testid="platform-wa-save"><Save className="w-4 h-4 mr-1.5" /> Salva</Button>
      </div>
    </div>
  );
};

export default PlatformWhatsApp;
